import { Component, input } from '@angular/core';
import { OpenAppointmentsResponse } from 'src/app/models/open-appointments.model';

@Component({
  selector: 'app-open-appointments-card',
  templateUrl: './open-appointments-card.component.html',
  styleUrls: ['./open-appointments-card.component.scss'],
  standalone: false,
})
export class OpenAppointmentsCardComponent {
  /* List of open appointments displayed in the card */
  openAppointments = input<OpenAppointmentsResponse[]>([]);

  /* Indicates whether the component is rendered in mobile context */
  isMobileApp = input<boolean>(false);

}
